import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BalanceSheetSourceEnum } from '@zaoblako/shared/modules/catalog/enums/balance-sheet-source.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string represenations of {@link BalanceSheetSourceEnum} enumeration values */
export const BalanceSheetSourceEnumI18n: EnumI18nInterface<BalanceSheetSourceEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [BalanceSheetSourceEnum.DEBIT_TURNOVER]: 'Обороты дебет',
    [BalanceSheetSourceEnum.CREDIT_TURNOVER]: 'Обороты кредит',
    [BalanceSheetSourceEnum.BALANCE_TURNOVER]: 'Обороты сальдо',
    [BalanceSheetSourceEnum.INITIAL_BALANCE]: 'Сальдо на начало периода',
  },
  [I18nLocalesEnum.EN_US]: {
    [BalanceSheetSourceEnum.DEBIT_TURNOVER]: 'Debit turnover',
    [BalanceSheetSourceEnum.CREDIT_TURNOVER]: 'Credit turnover',
    [BalanceSheetSourceEnum.BALANCE_TURNOVER]: 'Balance turnover',
    [BalanceSheetSourceEnum.INITIAL_BALANCE]: 'Сальдо на начало периода',
  },
};
